
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/switch.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-weet-switch-demo-basic","docs-weet-switch-demo-disable","docs-weet-switch-demo-loading"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/switch.md?type=demo')
};